import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Landmark } from "lucide-react";
import { apiClient } from "@/lib/apiClient";

/** Button: fehlende UID / Adresse / Rechtsform aller Kontakte aus dem Handelsregister übernehmen. */
export function ZefixEnrichButton({ companyId, onDone, testId = "zefix-enrich-btn" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await apiClient.post(`/companies/${companyId}/contacts/zefix-enrich`, { only_missing: true });
      const d = r.data;
      if (d.filled > 0) toast.success(`${d.filled} von ${d.checked} Kontakten mit Handelsregister-Daten ergänzt`);
      else toast.info(`${d.checked} Kontakte geprüft – nichts zu ergänzen${d.not_found ? ` (${d.not_found} nicht im HR gefunden)` : ""}`);
      onDone?.(d);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Handelsregister-Abgleich fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button type="button" size="sm" variant="outline" onClick={run} disabled={busy} data-testid={testId}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Landmark className="h-4 w-4 mr-1.5" />}
      HR-Daten übernehmen
    </Button>
  );
}

/** Kleines Status-Badge neben der UID: aktiv / inaktiv / nicht gefunden. */
export function ZefixStatusBadge({ contact }) {
  const s = contact?.zefix_status;
  if (!s) return null;
  const cls = s === "aktiv" ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : s === "inaktiv" ? "bg-rose-50 text-rose-700 border-rose-200"
      : s === "mehrdeutig" ? "bg-amber-50 text-amber-700 border-amber-200"
        : "bg-slate-50 text-slate-500 border-slate-200";
  const label = s === "aktiv" ? "HR aktiv" : s === "inaktiv" ? "HR gelöscht" : s === "mehrdeutig" ? "HR: mehrere Treffer – UID erfassen" : "nicht im HR";
  return (
    <span className={`ml-1.5 inline-block rounded border px-1.5 py-0.5 text-[10px] font-medium ${cls}`} title={contact.zefix_name || ""} data-testid={`zefix-status-${contact._id}`}>
      {label}
    </span>
  );
}

/** Toast nach Kontakt-Erstellung, wenn Felder automatisch ergänzt wurden. */
export function toastEnriched(before, after) {
  const filled = ["vat_id", "address", "postal_code", "city"].filter((k) => !before[k] && after?.[k]);
  if (filled.length) {
    const map = { vat_id: "UID", address: "Adresse", postal_code: "PLZ", city: "Ort" };
    toast.success(`Aus Handelsregister übernommen: ${filled.map((k) => map[k]).join(", ")}`);
  }
}
